import { BundleStatus, ContractStatus } from '../constants';

export function useContractStatus() {
    const statusClass = (status: ContractStatus | BundleStatus) => {
        switch (status) {
            case ContractStatus.Active:
                return 'bg-green-100 text-green-700 border-green-400 border';
            case ContractStatus.Draft:
                return 'bg-gray-100 text-gray-700 border-gray-400 border';
            case ContractStatus.Negotiate:
                return 'bg-yellow-100 text-yellow-700 border-yellow-400 border';
            case ContractStatus.Request:
            case ContractStatus.Revise:
            case ContractStatus.Reactivate:
            case ContractStatus.Extend:
                return 'bg-purple-100 text-purple-700 border-purple-400 border';
            case ContractStatus.Signed:
                return 'bg-blue-100 text-blue-700 border-blue-400 border';
            case ContractStatus.Rejected:
            case ContractStatus.Declined:
            case ContractStatus.Withdrawn:
            case ContractStatus.Expired:
                return 'bg-red-100 text-red-700 border-red-400 border';
            default:
                return 'bg-neutral-100 text-neutral-700 border-neutral-400 border';
        }
    };

    return { statusClass };
}
